exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-item[data-v-aef6572a]{border:1px solid var(--lineBorderColor)}#gridContent[data-v-aef6572a]  .el-card__body{background-image:linear-gradient(90deg,var(--lineBorderColor) 1px,transparent 0),linear-gradient(180deg,var(--lineBorderColor) 1px,transparent 0);background-repeat:repeat}[data-v-aef6572a] .vue-grid-item>.vue-resizable-handle{z-index:10}", ""]);

// exports
